/**
 * Deployment environment, sourced from `VITE_ENV` (set per `.env.[mode]`
 * file). This is the *mode* axis — distinct from Vite's `import.meta.env.DEV`,
 * which only reflects dev-server-vs-build and is `false` for a staging build.
 */
export function isProduction(): boolean {
  return import.meta.env.VITE_ENV === 'production';
}

/**
 * Identity of the JS bundle this browser is running, from `VITE_APP_VERSION`
 * (set by the build/deploy pipeline — a release tag or commit sha). Reported
 * with a stale-bundle recurrence so ops can tell WHICH build is sending the
 * rejected parameter. `'unknown'` when the pipeline doesn't stamp it, which is
 * still useful: it says "an unstamped build", not "no report".
 */
export function bundleVersion(): string {
  const version = import.meta.env.VITE_APP_VERSION;
  return version && version.length > 0 ? version : 'unknown';
}
